import { type FC } from 'react'
import classnames from 'classnames'
import { Typography } from 'shared/ui'
import { type IAudioPlayerTranscriptItem } from 'shared/ui/AudioPlayer'
import styles from './styles.module.scss'

type ITranscriptContentProps = {
  items: IAudioPlayerTranscriptItem[]
}

export const TranscriptContent: FC<ITranscriptContentProps> = ({ items }) => {
  return (
    <div className={styles.wrapContent}>
      {items.map((item) => {
        return (
          <div key={item.id} className={styles.card}>
            {Boolean(item.speaker_label) && (
              <div className={styles.cardTitle}>
                <Typography
                  tag={'div'}
                  className={classnames(styles.cardTitle__count, {
                    [styles.cardTitle__count__one]: item.speaker_number === 1,
                    [styles.cardTitle__count__two]: item.speaker_number === 2,
                  })}
                  variant={'body-xs-medium'}
                  ariaLabel={'transcriptCount'}
                  color={'var(--content-primary-primary-inverted)'}
                >
                  {item.speaker_number}
                </Typography>
                <Typography
                  tag={'div'}
                  className={styles.cardTitle__text}
                  variant={'body-rg-semibold'}
                  ariaLabel={'transcriptTitle'}
                  color={'var(--content-primary-primary)'}
                >
                  {item.speaker_label}
                </Typography>
              </div>
            )}

            <Typography
              tag={'div'}
              variant={'body-rg-regular'}
              className={styles.card__text}
              ariaLabel={'transcriptText'}
              color={'var(--content-primary-primary)'}
            >
              {item.text}
            </Typography>
          </div>
        )
      })}
    </div>
  )
}
